import { useRef, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';

import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useUiuxStore from 'src/store/useUiuxStore';

import { SYS5020_R01Dto } from './Dto_SYS5020_R01';
import SearchSection_SYS5020_R01 from './SearchSection_SYS5020_R01';
import { Table_SYS5020_R01 } from './Table_SYS5020_R01';
import { Content_SYS5020_R01 } from './Content_SYS5020_R01';

export const Container_SYS5020_R01 = () => {
    const { tabList, setMessage } = useUiuxStore();
    const gridRef = useRef<AgGridReact<SYS5020_R01Dto>>(null);

    const { fetchData, handleExcelClick, initContainerData } = Content_SYS5020_R01({
        gridRef,
        tabList,
        setMessage,
    });

    return (
        <div className="content-container">
            <Actionbar
                onFetchClick={fetchData}
                onCreateClick={undefined}
                onDeleteClick={undefined}
                onSaveClick={undefined}
                onPrintClick={undefined}
                onExcelClick={handleExcelClick}
                onInitClick={initContainerData}
            />

            <SearchSection_SYS5020_R01 onEnterKeyDown={fetchData} />

            <div className="flex-1 overflow-hidden p-3">
                <Table_SYS5020_R01 gridRef={gridRef} />
            </div>

            <Message />
        </div>
    );
};

export default Container_SYS5020_R01;
